import React from 'react'

function Abouts() {
  return (
    <div className="abouts">
         <div className="container-fluid p-5 ">
            <div className="content ">
                <h1 className="title">About US</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.<br></br>
                     Vero ea debitis fuga aliquid eaque magni itaque incidunt voluptate,<br></br>
                      a asperiores ducimus excepturi hic necessitatibus<br></br>
                       fugiat quisquam deserunt quas harum eos voluptates.<br></br>
                     Aliquid voluptatibus sed veritatis quae alias, dicta deleniti quod?</p>
            </div>
        </div>

    </div>
  )
}

export default Abouts;